module.exports = __webpack_public_path__ + "img/cafe.203f3632.svg";